import OperationalReportPage from './OperationalReportPage';
export default function PriceGrnAuditReportPage(){return <OperationalReportPage kind="price-grn-audit"/>;}
